import SeparateWallEntity from '@/editor/entities/separateWallEntity';
import { globalStores } from '@/editor/stores';
import { EEntityType } from '@/editor/types';

export class SeparateWallManager {
  private _list: SeparateWallEntity[] = [];

  constructor() {}

  private getDataList() {
    const sepWallHiddenIds = globalStores.visibilityStore.getHiddenEntitiesIdsByEntityType(EEntityType.SeparateWall);
    return globalStores.separateWallStore.separateWallDatas.filter((data) => !sepWallHiddenIds.has(data.id));
  }

  getEntity(id: string) {
    for (const entity of this._list) {
      if (id === entity.id) {
        return entity;
      }
    }
  }

  deleteEntity(index: number) {
    if (index >= this._list.length || index < 0) return;
    this._list[index].dispose();
    this._list.splice(index, 1);
  }

  private addEntity(separateWallEntity: SeparateWallEntity) {
    this._list.push(separateWallEntity);
  }

  update() {
    const sepDatas = this.getDataList();
    const newSepDataMap = new Map(sepDatas.map((data) => [data.id, data]));

    for (let i = this._list.length - 1; i >= 0; i--) {
      const entity = this._list[i];
      const newSepData = newSepDataMap.get(entity.id);
      if (newSepData) {
        entity.update(newSepData);
      } else {
        this.deleteEntity(i);
      }

      newSepDataMap.delete(entity.id);
    }

    for (const addedSepData of newSepDataMap.values()) {
      const separateWallEntity = new SeparateWallEntity({ id: addedSepData.id });
      separateWallEntity.update(addedSepData);
      this.addEntity(separateWallEntity);
    }
  }

  updateVisible(_v: boolean, _ids: string[]) {}
}
